"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getIndexBefore_1 = __importDefault(require("../query/getIndexBefore"));
const constants_1 = require("../constants");
function backspace(editorState, start, end) {
    let newEditorState = editorState;
    const previousCharIndex = getIndexBefore_1.default(editorState.list.value, start + 1, (ch) => {
        if (ch == null) {
            return false;
        }
        if ('char' in ch) {
            return true;
        }
        return ch.type === 'block-end';
    });
    if (previousCharIndex != null) {
        let _start = previousCharIndex - 1;
        newEditorState = editorState.change({
            isBoundary: editorState.lastChangeType !== constants_1.COMMAND.BACKSPACE,
            type: constants_1.COMMAND.BACKSPACE,
            start: _start,
            end,
            value: []
        }).change({
            type: constants_1.COMMAND.BACKSPACE,
            start: _start,
            end: _start,
            value: [],
        });
    }
    return newEditorState;
}
exports.default = backspace;
//# sourceMappingURL=backspace.js.map